var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSubmitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0ZM30 20.5C30 23.26 27.76 25.5 25 25.5H16.83L18.42 27.09C19.2 27.87 19.2 29.14 18.42 29.92C17.64 30.7 16.37 30.7 15.59 29.92L10.59 24.92C10.4 24.73 10.25 24.51 10.16 24.27C10.06 24.03 10.01 23.78 10.01 23.5C10.01 23.22 10.06 22.97 10.16 22.73C10.26 22.5 10.4 22.28 10.59 22.09L15.59 17.09C16.37 16.31 17.64 16.31 18.42 17.09C19.2 17.87 19.2 19.14 18.42 19.92L16.83 21.51H25C25.55 21.51 26 21.06 26 20.51V14.51C26 13.96 25.55 13.51 25 13.51H20.89C19.79 13.51 18.89 12.61 18.89 11.51C18.89 10.41 19.79 9.51 20.89 9.51H25C27.76 9.51 30 11.75 30 14.51V20.51V20.5Z",
    fill: "#38A3A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSubmitIcon);
export default __webpack_public_path__ + "static/media/chat-submit-icon.29d6c6ada8d080d76023b81889e44eb5.svg";
export { ForwardRef as ReactComponent };